/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WhitelabelSettingWriteModel
 */
export interface WhitelabelSettingWriteModel {
    /**
     * 
     * @type {string}
     * @memberof WhitelabelSettingWriteModel
     */
    rowKey: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelSettingWriteModel
     */
    value: string;
}

/**
 * Check if a given object implements the WhitelabelSettingWriteModel interface.
 */
export function instanceOfWhitelabelSettingWriteModel(value: object): value is WhitelabelSettingWriteModel {
    if (!('rowKey' in value) || value['rowKey'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function WhitelabelSettingWriteModelFromJSON(json: any): WhitelabelSettingWriteModel {
    return WhitelabelSettingWriteModelFromJSONTyped(json, false);
}

export function WhitelabelSettingWriteModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WhitelabelSettingWriteModel {
    if (json == null) {
        return json;
    }
    return {
        
        'rowKey': json['rowKey'],
        'value': json['value'],
    };
}

export function WhitelabelSettingWriteModelToJSON(json: any): WhitelabelSettingWriteModel {
    return WhitelabelSettingWriteModelToJSONTyped(json, false);
}

export function WhitelabelSettingWriteModelToJSONTyped(value?: WhitelabelSettingWriteModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rowKey': value['rowKey'],
        'value': value['value'],
    };
}

